import { useTranslation } from 'react-i18next';
import { ContainerWrapper, Title, ContactWrapper, Card, CardTitle, CardIcon, CardInfo, CardDescription } from './style';
import { Flex } from '@/layout';
import useResize from '@/hooks/useResize';

const Contact = () => {
  // @ts-ignore
  const { t } = useTranslation();
  const { isMobile, isTablet } = useResize();

  return (
    <ContainerWrapper>
      <Title id="Contact">{t('pages.index.Contact.title')}</Title>
      <ContactWrapper isTablet={isTablet}>
        <Flex gridGap={20} flexDirection={isMobile ? 'column' : 'row'} style={{ height: isMobile ? 220 : 'auto', width: isTablet ? 'unset' : '50%' }}>
          <Card isTablet={isTablet} isMobile={isMobile}>
            <CardIcon src="/images/index/call.svg" />
            <CardInfo>
              <CardTitle>{t('pages.index.Contact.generalEnquiry')}</CardTitle>
              <CardDescription>(+852) 3580 8280</CardDescription>
            </CardInfo>
          </Card>
          <Card isTablet={isTablet} isMobile={isMobile}>
            <CardIcon src="/images/index/call.svg" />
            <CardInfo>
              <CardTitle>{t('pages.index.Contact.technicalSupport')}</CardTitle>
              <CardDescription>(+852) 3580 8279</CardDescription>
            </CardInfo>
          </Card>
        </Flex>
        <Flex gridGap={20} flexDirection={isMobile ? 'column' : 'row'} style={{ height: isMobile ? 220 : 'auto', width: isTablet ? 'unset' : '50%' }}>
          <Card isTablet={isTablet} isMobile={isMobile}>
            <CardIcon src="/images/index/mail.svg" />
            <CardInfo>
              <CardTitle>{t('pages.index.Contact.email')}</CardTitle>
              <CardDescription>
                <a href="mailto:dealmaking@ebram.org">
                  <span>dealmaking@ebram.org</span>
                </a>
              </CardDescription>
            </CardInfo>
          </Card>
          <Card isTablet={isTablet} isMobile={isMobile}>
            <CardIcon src="/images/index/WhateAPP_blue.svg" />
            <CardInfo>
              <CardTitle>WhatsApp</CardTitle>
              <CardDescription>
                <a href="https://wa.me/85266981322" target="_blank" rel="noopener noreferrer">
                  <span>(+852) 6698 1322</span>
                </a>
              </CardDescription>
            </CardInfo>
          </Card>
        </Flex>
      </ContactWrapper>
    </ContainerWrapper>
  );
};

export default Contact;
